'use client'

import { WithT } from '@/locales/types'
import { Card } from './Card'
import { useMemo } from 'react'
import { createT } from '@/locales/index'
import classNames from 'classnames'

type Props = {
  type?: 'SEARCH' | 'NON-SEARCH'
  text?: string
  className?: string
}

export const EmptyCard = ({
  translations,
  text,
  type,
  className,
}: WithT<Props>) => {
  const t = createT(translations)

  const emptyText = useMemo(() => {
    if (text) {
      return text
    }

    if (type === 'SEARCH') {
      return t('empty-list-search')
    }

    if (type === 'NON-SEARCH') {
      return t('empty-list')
    }
  }, [t, text, type])

  return (
    <Card
      className={classNames(
        'flex items-center justify-center text-body1 text-gray-600 w-full bg-transparent',
        className,
      )}
    >
      {emptyText}
    </Card>
  )
}
